// LumiDog — scripts propios (vanilla, sin dependencias)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCifras();
  initComparador();
  initGaleriaProducto();
  initSelectorVariantes();
  initCompraForm();
  initGuiaTallasEnlace();
  initFaq();
  initDesplegables();
  initCarruselResenas();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.16, rootMargin: '0px 0px -40px 0px' });
  els.forEach(function (el) { obs.observe(el); });
}

function initCifras() {
  var els = document.querySelectorAll('[data-mt-cifra]');
  if (!els.length) return;
  var animado = new WeakSet();
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting || animado.has(entry.target)) return;
      animado.add(entry.target);
      var el = entry.target;
      var fin = parseFloat(el.getAttribute('data-mt-cifra')) || 0;
      var sufijo = el.getAttribute('data-mt-sufijo') || '';
      var decimales = parseInt(el.getAttribute('data-mt-decimales') || '0', 10);
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var prog = Math.min((ts - inicio) / duracion, 1);
        var facilitado = 1 - Math.pow(1 - prog, 3);
        el.textContent = (fin * facilitado).toFixed(decimales) + sufijo;
        if (prog < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { obs.observe(el); });
}

function initComparador() {
  document.querySelectorAll('[data-mt-comparador]').forEach(function (wrap) {
    var handle = wrap.querySelector('.mt-comp-asa');
    var despues = wrap.querySelector('.mt-comp-despues');
    if (!handle || !despues) return;
    var arrastrando = false;
    function fijar(x) {
      var rect = wrap.getBoundingClientRect();
      var pct = Math.min(1, Math.max(0, (x - rect.left) / rect.width));
      despues.style.clipPath = 'inset(0 ' + (100 - pct * 100) + '% 0 0)';
      handle.style.left = (pct * 100) + '%';
    }
    fijar(wrap.getBoundingClientRect().left + wrap.getBoundingClientRect().width / 2);
    function onDown(e) { arrastrando = true; wrap.classList.add('mt-arrastrando'); }
    function onUp() { arrastrando = false; wrap.classList.remove('mt-arrastrando'); }
    function onMove(e) {
      if (!arrastrando) return;
      var x = e.touches ? e.touches[0].clientX : e.clientX;
      fijar(x);
    }
    handle.addEventListener('mousedown', onDown);
    handle.addEventListener('touchstart', onDown, { passive: true });
    window.addEventListener('mouseup', onUp);
    window.addEventListener('touchend', onUp);
    window.addEventListener('mousemove', onMove);
    window.addEventListener('touchmove', onMove, { passive: true });
    wrap.addEventListener('click', function (e) { fijar(e.clientX); });
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-galeria-principal]');
  var minis = galeria.querySelectorAll('[data-mt-galeria-mini]');
  minis.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src || !principal) return;
      principal.style.opacity = '0';
      setTimeout(function () {
        principal.src = src;
        principal.style.opacity = '1';
      }, 160);
      minis.forEach(function (m) { m.classList.remove('mt-activa'); });
      mini.classList.add('mt-activa');
    });
  });
}

function initSelectorVariantes() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var seleccion = {};
  var inputId = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('[data-mt-precio]');
  var precioTachadoEl = document.querySelector('[data-mt-precio-tachado]');
  var botonComprar = form.querySelector('[data-mt-boton-comprar]');

  function encontrarVariante() {
    return variantes.find(function (v) {
      return v.opciones.every(function (o, i) { return seleccion[i] === o; });
    });
  }

  function actualizar() {
    var v = encontrarVariante();
    if (!v) return;
    inputId.value = v.id;
    if (precioEl) precioEl.textContent = v.precio_fmt;
    if (precioTachadoEl) {
      if (v.precio_comparado_fmt) { precioTachadoEl.textContent = v.precio_comparado_fmt; precioTachadoEl.style.display = ''; }
      else { precioTachadoEl.style.display = 'none'; }
    }
    if (botonComprar) {
      if (v.disponible) { botonComprar.disabled = false; botonComprar.textContent = botonComprar.getAttribute('data-texto-disponible'); }
      else { botonComprar.disabled = true; botonComprar.textContent = botonComprar.getAttribute('data-texto-agotado'); }
    }
    var botonPagar = form.querySelector('[data-mt-boton-pagar]');
    if (botonPagar) botonPagar.disabled = !v.disponible;
    var descuentoPill = document.querySelector('[data-mt-descuento-pill]');
    if (descuentoPill) {
      if (v.descuento_pct) { descuentoPill.textContent = '-' + v.descuento_pct + '%'; descuentoPill.hidden = false; }
      else { descuentoPill.hidden = true; }
    }
    var agotadoPill = document.querySelector('[data-mt-agotado-pill]');
    if (agotadoPill) agotadoPill.hidden = v.disponible;
    if (v.imagen) {
      var principal = document.querySelector('[data-mt-galeria-principal]');
      if (principal && principal.src.split('?')[0] !== v.imagen.split('?')[0]) {
        principal.style.opacity = '0';
        setTimeout(function () {
          principal.src = v.imagen;
          principal.style.opacity = '1';
        }, 160);
        document.querySelectorAll('[data-mt-galeria-mini]').forEach(function (m) { m.classList.remove('mt-activa'); });
      }
    }
  }

  form.querySelectorAll('[data-mt-opcion]').forEach(function (grupo) {
    var indice = parseInt(grupo.getAttribute('data-mt-opcion'), 10);
    var botones = grupo.querySelectorAll('[data-valor]');
    botones.forEach(function (btn) {
      if (btn.classList.contains('mt-opcion-activa')) seleccion[indice] = btn.getAttribute('data-valor');
      btn.addEventListener('click', function () {
        botones.forEach(function (b) { b.classList.remove('mt-opcion-activa'); });
        btn.classList.add('mt-opcion-activa');
        seleccion[indice] = btn.getAttribute('data-valor');
        actualizar();
      });
    });
  });
  actualizar();
}

function initCompraForm() {
  var form = document.querySelector('[data-mt-producto-form]');
  if (!form) return;
  var aviso = document.querySelector('[data-mt-aviso-carrito]');
  var avisoTimer = null;

  function mostrarAviso(texto) {
    if (!aviso) return;
    aviso.textContent = texto;
    aviso.hidden = false;
    requestAnimationFrame(function () { aviso.classList.add('mt-visible-aviso'); });
    clearTimeout(avisoTimer);
    avisoTimer = setTimeout(function () {
      aviso.classList.remove('mt-visible-aviso');
      setTimeout(function () { aviso.hidden = true; }, 300);
    }, 4000);
  }

  function actualizarBurbujaCarrito() {
    fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var burbuja = document.getElementById('cart-icon-bubble');
        if (burbuja && data['cart-icon-bubble'] !== undefined) {
          burbuja.innerHTML = data['cart-icon-bubble'];
        }
      })
      .catch(function () {});
  }

  form.addEventListener('submit', function (evt) {
    evt.preventDefault();
    var submitter = evt.submitter;
    var accion = submitter ? submitter.getAttribute('data-mt-accion') : 'carrito';
    var botonesEnvio = form.querySelectorAll('button[type="submit"]');
    botonesEnvio.forEach(function (b) { b.disabled = true; });

    var datos = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: datos,
    })
      .then(function (r) { return r.json().then(function (json) { return { ok: r.ok, json: json }; }); })
      .then(function (res) {
        botonesEnvio.forEach(function (b) { b.disabled = false; });
        if (!res.ok) {
          mostrarAviso(res.json && res.json.description ? res.json.description : 'No se pudo añadir al carrito. Inténtalo de nuevo.');
          return;
        }
        actualizarBurbujaCarrito();
        if (accion === 'pagar') {
          window.location.href = '/cart';
        } else {
          var textoAviso = form.getAttribute('data-mt-texto-anadido') || '✓ Añadido al carrito.';
          mostrarAviso(textoAviso);
        }
      })
      .catch(function () {
        botonesEnvio.forEach(function (b) { b.disabled = false; });
        mostrarAviso('No se pudo añadir al carrito. Comprueba tu conexión e inténtalo de nuevo.');
      });
  });
}

function initGuiaTallasEnlace() {
  document.querySelectorAll('[data-mt-ir-a-guia-tallas]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var destino = document.getElementById('mt-guia-tallas');
      if (destino) destino.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
}

function initFaq() {
  document.querySelectorAll('[data-mt-faq]').forEach(function (grupo) {
    var items = grupo.querySelectorAll('[data-mt-faq-item]');
    items.forEach(function (item) {
      var pregunta = item.querySelector('[data-mt-faq-pregunta]');
      if (!pregunta) return;
      pregunta.addEventListener('click', function () {
        var abierto = item.classList.contains('mt-abierto');
        items.forEach(function (i) { i.classList.remove('mt-abierto'); });
        if (!abierto) item.classList.add('mt-abierto');
      });
    });
  });
}

function initDesplegables() {
  document.querySelectorAll('[data-mt-desplegable]').forEach(function (caja) {
    var boton = caja.querySelector('[data-mt-desplegable-boton]');
    if (!boton) return;
    boton.addEventListener('click', function () {
      caja.classList.toggle('mt-abierto');
    });
  });
}

function initCarruselResenas() {
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('[data-mt-resenas-carrusel]').forEach(function (wrap) {
    var pista = wrap.querySelector('[data-mt-resenas-pista]');
    var prev = wrap.querySelector('[data-mt-resenas-prev]');
    var next = wrap.querySelector('[data-mt-resenas-next]');
    var contenedor = wrap.closest('.mt-section') || wrap;
    var puntos = contenedor.querySelectorAll('[data-mt-resenas-punto]');
    var slides = pista ? pista.querySelectorAll('.mt-resena-slide') : [];
    if (!pista || slides.length === 0) return;

    var total = slides.length;
    var indice = 0;
    var timer = null;
    var autoplay = wrap.getAttribute('data-autoplay') === 'true' && total > 1 && !reduceMotion;
    var intervalo = parseInt(wrap.getAttribute('data-intervalo'), 10) || 6000;

    function ir(i) {
      indice = (i + total) % total;
      pista.style.transform = 'translateX(-' + (indice * 100) + '%)';
      puntos.forEach(function (p, pi) { p.classList.toggle('mt-activo', pi === indice); });
    }

    function iniciarAuto() {
      if (!autoplay) return;
      detenerAuto();
      timer = setInterval(function () { ir(indice + 1); }, intervalo);
    }
    function detenerAuto() {
      if (timer) { clearInterval(timer); timer = null; }
    }

    if (prev) prev.addEventListener('click', function () { ir(indice - 1); iniciarAuto(); });
    if (next) next.addEventListener('click', function () { ir(indice + 1); iniciarAuto(); });
    puntos.forEach(function (p, pi) {
      p.addEventListener('click', function () { ir(pi); iniciarAuto(); });
    });

    wrap.addEventListener('mouseenter', detenerAuto);
    wrap.addEventListener('mouseleave', iniciarAuto);
    wrap.addEventListener('focusin', detenerAuto);
    wrap.addEventListener('focusout', iniciarAuto);

    ir(0);
    iniciarAuto();
  });
}
